import React, { useState } from 'react';
import './Actividades.css';

/* ==================== DATOS ACTUALIZADOS ==================== */
const datosActividades = [
  /* ---------- INFANTIL / ESCOLAR ---------- */
  {
    grupo: 'Infantil',
    actividades: [
      { nombre: 'Pequeteca', dias: ['Martes', 'Jueves'], horario: '16:00 – 18:00', lugar: 'Guardería' },
      { nombre: 'Gimnasia Rítmica', dias: ['Viernes'], horario: '16:00 – 18:00', lugar: 'Casa de la Cultura' },

      { nombre: 'Fútbol (Jesús)', dias: ['Lunes', 'Miércoles'], horario: '16:00 – 17:00', lugar: 'Polideportivo / Campo' },
      { nombre: 'Fútbol (Aitor)', dias: ['Lunes', 'Viernes'], horario: '16:00 – 17:00', lugar: 'Polideportivo / Campo' },
      { nombre: 'Fútbol (Sergio & José)', dias: ['Miércoles', 'Viernes'], horario: '16:00 – 17:00 / 17:00 – 18:00', lugar: 'Polideportivo / Campo' },

      { nombre: 'Música con Juanjo (AMPA)', dias: ['Viernes'], horario: '18:00 – 20:00', lugar: 'Aula de Música' },
      { nombre: 'Pintura y Dibujo (AMPA)', dias: ['Viernes'], horario: '18:30 – 20:30', lugar: 'Antigua Biblioteca (C/ Orán)' },
    ],
  },

  /* ---------- ADULTOS ---------- */
  {
    grupo: 'Adultos',
    actividades: [
      { nombre: 'Pilates (mañanas)', dias: ['Martes', 'Jueves'], horario: '11:15 – 12:15', lugar: 'Casa de la Cultura' },
      { nombre: 'Pilates (tarde)', dias: ['Martes', 'Jueves'], horario: '19:00 – 20:00', lugar: 'Casa de la Cultura' },

      { nombre: 'Zumba Adultos (AMPA)', dias: ['Martes', 'Jueves'], horario: '20:15 – 21:15', lugar: 'Casa de la Cultura' },
      { nombre: 'Yoga Adultos (AMPA)', dias: ['Lunes', 'Miércoles'], horario: '21:00 – ?', lugar: 'Casa de la Cultura' },

      { nombre: 'Escuela de Inglés', dias: ['Martes', 'Jueves'], horario: '16:00 – 18:00 / 16:00 – 19:00', lugar: 'Aula Adultos' },
      { nombre: 'Ganchillo', dias: ['Lunes', 'Miércoles'], horario: '16:00 – 18:00', lugar: 'Aula Adultos' },

      { nombre: 'Taller de Español', dias: ['Lunes', 'Martes'], horario: '09:15 – 10:15 / 12:00 – 13:00', lugar: 'Aula Adultos' },
      { nombre: 'SEPAP Mejora-T', dias: ['Martes', 'Jueves'], horario: '09:00 – 11:20 / 11:30 – 13:50', lugar: 'Aula Adultos' },

      { nombre: 'Proyecto NERA', dias: ['Miércoles'], horario: '16:30 – 18:00', lugar: 'Hogar del Jubilado' },
      { nombre: 'Fisioterapia Mayores', dias: ['Viernes'], horario: '16:00 – 17:00', lugar: 'Aula Adultos' },
    ],
  },

  /* ---------- MAYORES ---------- */
  {
    grupo: 'Mayores',
    actividades: [
      { nombre: 'Gimnasia Mayores', dias: ['Martes', 'Jueves'], horario: '18:00 – 19:00', lugar: 'Casa de la Cultura' },
      { nombre: 'Taller de Memoria', dias: ['Lunes'], horario: '16:30 – 18:00', lugar: 'Hogar del Jubilado' },
      { nombre: 'Juegos (Asoc. Jubilados)', dias: ['Martes', 'Jueves'], horario: '16:00 – 18:00', lugar: 'Hogar del Jubilado' },
    ],
  },
];

/* ============================================================ */

export default function Actividades() {
  const [grupoAbierto, setGrupoAbierto] = useState(null);
  const toggleGrupo = (g) => setGrupoAbierto(grupoAbierto === g ? null : g);

  return (
    <section className="actividades">
      <div className="container">
        <h1>Actividades Municipales 2024 / 2025</h1>
        <p>Consulta la programación agrupada por edades.</p>

        {datosActividades.map((bloque) => (
          <div key={bloque.grupo} className="grupo-actividad">
            <div className="encabezado-grupo" onClick={() => toggleGrupo(bloque.grupo)}>
              <h2>{bloque.grupo}</h2>
              <span>{grupoAbierto === bloque.grupo ? '−' : '+'}</span>
            </div>

            {grupoAbierto === bloque.grupo && (
              <div class="tabla-actividades-wrapper">
                <table className="tabla-actividades">
                  <thead>
                    <tr>
                      <th>Actividad</th>
                      <th>Días</th>
                      <th>Horario</th>
                      <th>Ubicación</th>
                    </tr>
                  </thead>
                  <tbody>
                    {bloque.actividades.map((act, i) => (
                      <tr key={i}>
                        <td>{act.nombre}</td>
                        <td>{act.dias.join(', ')}</td>
                        <td>{act.horario}</td>
                        <td>{act.lugar}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
